module.exports = __webpack_public_path__ + "static/media/tablet-mockup.effc1105.png";